import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _URL from "@babel/runtime-corejs3/core-js/url";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { GenericModal } from "@Shared/components/modals";
import Draggable from "vuedraggable";
import { mapActions, mapGetters } from "vuex";
import PdfThumbnail from "./pdf-thumbnail";
import PdfPreview from "./pdf-preview";
import { PDFDocument as PDFLib, degrees } from "pdf-lib";
const pdfjsLib = window["pdfjs-dist/build/pdf"];
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.0.279/pdf.worker.min.js";
import { DOWNLOAD_COMBINED_PDF, UPLOAD_DOCUMENT_TO_CLASSIFICATION, CREATE_DOCUMENT_CLASSIFICATIONS, LOAD_DOCUMENTS } from "../../store/documents-actions";
import { GENERATED_PDF_CLASIFICATION_TYPE, showToast } from "../../../../../../../../shared/utils/constants";
import Err from "../../../../../../routes/error";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { openFileDialog } from "@Shared/utils/utils";
import Amplitude from "../../../../../../../../shared/utils/amplitude";
import PreviewLoader from "./pdf-preview-loader";
import { GENERATED_PDF_CLASSIFICATION_ID } from "../../store/documents-getters";
import { defer, sortBy } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PreviewCombinedPDFModal",
  components: {
    PdfThumbnail,
    PdfPreview,
    Draggable,
    SimpleButton,
    PreviewLoader,
    GenericModal
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    clientDetails: {
      type: Object,
      required: true
    },
    documentClassifications: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      pages: [],
      maxPages: null,
      pdfDoc: null,
      previewing: null,
      currentPage: null,
      pdfBytes: null,
      saving: null,
      downloading: null,
      progress: null,
      savingStatus: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("DocumentsStore", [GENERATED_PDF_CLASSIFICATION_ID])), {}, {
    generatedPdfClassificationId() {
      return this.GENERATED_PDF_CLASSIFICATION_ID(this.applicationId);
    },
    clientName() {
      const {
        givenName,
        familyName
      } = this.clientDetails;
      return `${givenName} ${familyName}`;
    },
    renderedPages() {
      var _context;
      return _filterInstanceProperty(_context = this.pages).call(_context, page => page.rendered);
    },
    rendering() {
      if (this.loading || this.maxPages === null) return false;
      return this.renderedPages.length !== this.maxPages;
    },
    isFirstPage() {
      return this.currentPage === 1;
    },
    isLastPage() {
      return this.currentPage === this.maxPages;
    },
    pageOrder() {
      var _context2;
      return _mapInstanceProperty(_context2 = this.pages).call(_context2, page => page.include ? page.pageNumber : -1);
    },
    details() {
      return {
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      };
    },
    progressMessage() {
      return this.$t("documents.combinePdf.progress")[this.progress];
    },
    progressClass() {
      const classMap = {
        combining: "text-primary",
        downloading: "text-secondary",
        rendering: "text-success"
      };
      return classMap[this.progress];
    }
  }),
  watch: {
    pageOrder(value) {
      if (this.rendering) return;
      this.log("Re-ordered pages", {
        order: value
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [DOWNLOAD_COMBINED_PDF, UPLOAD_DOCUMENT_TO_CLASSIFICATION, CREATE_DOCUMENT_CLASSIFICATIONS, LOAD_DOCUMENTS])), {}, {
    async init() {
      this.log("Getting Combined link");
      this.progress = "combining";
      this.downloadCombined().then(async ({
        url: pdfURL
      }) => {
        let pdfBytes = [];
        this.progress = "downloading";
        this.log("Downloading pdf");
        const pdfResponse = await fetch(pdfURL);
        pdfBytes = await pdfResponse.arrayBuffer();
        pdfBytes = new Uint8Array(pdfBytes);
        this.pdfBytes = pdfBytes;
        this.loading = false;
        this.progress = "rendering";
        this.log("Preview In Progress - Thumbnails");
        await this.pdfToThumbs(pdfBytes);
        this.progress = null;
        this.log("Loaded");
      });
      this.$emit("show");
    },
    reset() {
      this.loading = true;
      this.pages = [];
      this.maxPages = null;
      this.pdfDoc = null;
      this.previewing = null;
      this.currentPage = null;
      this.pdfBytes = null;
      this.saving = null;
      this.downloading = null;
      this.progress = null;
      this.savingStatus = null;
      this.$emit("hide");
    },
    getOrder(container) {
      const order = [];
      container.children(".page").each((index, element) => {
        const page = $(element);
        if (page.hasClass("hidden")) {
          order.push(-1);
        } else {
          order.push(_parseInt($(element)[0].dataset.pageNumber));
        }
      });
      return order;
    },
    async pdfToThumbs(rawPdf) {
      try {
        const pdfDoc = await pdfjsLib.getDocument(rawPdf).promise;
        this.pdfDoc = pdfDoc;
        const maxPages = pdfDoc.numPages;
        this.maxPages = maxPages;
        for (let currentPage = 1; currentPage <= maxPages; currentPage++) {
          const page = await pdfDoc.getPage(currentPage);
          await this.renderPage(page, currentPage);
        }
      } catch (error) {
        Err.handle(error, {
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        }, "invalidPDF");
        this.closeModal();
      }
    },
    log(message, additionalDetails = {}) {
      Amplitude.logEvent(`PDF Preview ${message}`, _objectSpread(_objectSpread({
        page: "application",
        subpage: "documents"
      }, this.details), additionalDetails));
    },
    async renderPage(page, currentPage, isUpdate = false) {
      try {
        var _this$pages$rotation, _this$pages;
        const rotation = (_this$pages$rotation = (_this$pages = this.pages[currentPage - 1]) == null ? void 0 : _this$pages.rotation) != null ? _this$pages$rotation : page.rotate;
        const viewport = page.getViewport({
          scale: 1,
          rotation
        });
        if (!isUpdate) this.addPage(currentPage, rotation);
        const renderContext = await this.getRenderContext(currentPage, viewport);
        await page.render(renderContext).promise;
        this.markPageAsRendered(currentPage);
      } catch (e) {
        this.log(e);
      }
    },
    markPageAsRendered(currentPage) {
      defer(() => {
        this.pages[currentPage - 1].rendered = true;
      });
    },
    addPage(currentPage, rotation) {
      this.pages.push({
        pageNumber: currentPage,
        rendered: false,
        order: currentPage - 1,
        include: true,
        rotation
      });
    },
    async getRenderContext(currentPage, viewport) {
      return new _Promise((resolve, reject) => {
        defer(() => {
          var _this$$refs, _this$$refs$pages;
          const node = this == null ? void 0 : (_this$$refs = this.$refs) == null ? void 0 : (_this$$refs$pages = _this$$refs.pages) == null ? void 0 : _this$$refs$pages[currentPage - 1];
          if (!node) {
            return reject("aborted");
          }
          const canvas = node.$refs.canvas;
          const canvasCtx = canvas.getContext("2d", {
            alpha: false
          });
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          resolve({
            canvasContext: canvasCtx,
            viewport: viewport
          });
        });
      });
    },
    async downloadCombined() {
      return this.DOWNLOAD_COMBINED_PDF({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        documentRequestIds: this.documentClassifications
      });
    },
    handleHide(pageNumber) {
      var _context3;
      const item = _findInstanceProperty(_context3 = this.pages).call(_context3, page => pageNumber === page.pageNumber);
      item.include = !item.include;
    },
    handlePreview(pageNumber, go = null, rotation = 0) {
      this.log(`Previewing page ${pageNumber} ${pageNumber ? "using icon" : "using arrows"}`);
      if (pageNumber) {
        this.currentPage = pageNumber;
      }
      if (go) {
        this.currentPage = this.currentPage + go;
        pageNumber = this.currentPage;
      }
      const pageArrayIndex = pageNumber - 1;
      if (rotation) {
        this.pages[pageArrayIndex].rotation += rotation;
      }
      this.previewing = true;
      this.$nextTick(() => {
        this.pdfDoc.getPage(+pageNumber).then(page => {
          var _this$pages$pageArray, _this$pages$pageArray2;
          const canvasNode = this.$refs.preview.$refs.canvas;
          const canvasCtx = canvasNode.getContext("2d", {
            alpha: false
          });
          const viewport = page.getViewport({
            scale: 1,
            rotation: (_this$pages$pageArray = (_this$pages$pageArray2 = this.pages[pageArrayIndex]) == null ? void 0 : _this$pages$pageArray2.rotation) != null ? _this$pages$pageArray : page.rotate
          });
          canvasNode.height = viewport.height;
          canvasNode.width = viewport.width;
          const renderContext = {
            canvasContext: canvasCtx,
            viewport: viewport
          };
          page.render(renderContext).promise;
          this.renderPage(page, pageNumber, true);
        });
      });
    },
    closePreview() {
      this.log("Closed preview");
      this.previewing = false;
      this.currentPage = null;
    },
    async reorderPdf(rawPdf, newOrder) {
      const pdfDoc = await PDFLib.load(rawPdf);
      const pages = pdfDoc.getPages();
      let toDelete = [];
      for (let currentPage = 0; currentPage < newOrder.length; currentPage++) {
        var _this$pages$currentPa, _this$pages$currentPa2;
        pdfDoc.removePage(currentPage);
        pages[currentPage].setRotation(degrees((_this$pages$currentPa = (_this$pages$currentPa2 = this.pages[currentPage]) == null ? void 0 : _this$pages$currentPa2.rotation) != null ? _this$pages$currentPa : 0));

        //If mark as deleted
        if (newOrder[currentPage] === -1) {
          //Save the page number
          toDelete.push(currentPage + 1);
          //Keep it in place
          pdfDoc.insertPage(currentPage, pages[currentPage]);
        } else {
          //Swap
          pdfDoc.insertPage(currentPage, pages[newOrder[currentPage] - 1]);
        }
      }
      toDelete = sortBy(toDelete);
      for (let i = 0; i < toDelete.length; i++) {
        pdfDoc.removePage(toDelete[i] - i - 1);
      }
      const pdfBytes = await pdfDoc.save();
      return pdfBytes;
    },
    async handleSave() {
      const dateTimeStamp = moment().format("MM-DD-YYYY - hhmma");
      const consolidatedDocumentName = `${this.$t("documents.consolidatedPDFFor", {
        name: this.clientName
      })} - ${dateTimeStamp}.pdf`;
      defer(async () => {
        this.downloading = true;
        this.log("Download started");
        const newPdf = await this.reorderPdf(this.pdfBytes, this.pageOrder);
        const fileUri = _URL.createObjectURL(new Blob([newPdf], {
          type: "application/pdf"
        }));
        this.log("Download finished");
        openFileDialog(fileUri, consolidatedDocumentName);
        this.downloading = false;
      });
    },
    closeModal() {
      this.log("Done");
      $("#pdf-editor-modal").modal("hide");
    },
    async handleSaveToDocuments() {
      try {
        this.log("Save to documents started");
        this.saving = true;
        const dateTimeStamp = moment().format("MM-DD-YYYY - hhmma");
        const consolidatedDocumentName = `Consolidated PDF for ${this.clientName} - ${dateTimeStamp}.pdf`;
        const newPdf = await this.reorderPdf(this.pdfBytes, this.pageOrder);
        const consolidatedPDFFile = new Blob([newPdf], {
          type: "application/pdf"
        });
        let documentRequestId = this.generatedPdfClassificationId;
        if (!documentRequestId) {
          const [responseId] = await this.CREATE_DOCUMENT_CLASSIFICATIONS({
            applicationId: this.applicationId,
            clientUsername: this.clientUsername,
            documentRequests: [{
              documentType: GENERATED_PDF_CLASIFICATION_TYPE(),
              description: ""
            }]
          });
          if (!responseId) return;
          documentRequestId = responseId.documentRequestId;
        }
        const {
          withError
        } = await this.UPLOAD_DOCUMENT_TO_CLASSIFICATION({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          classification: {
            documentRequestId,
            classification: GENERATED_PDF_CLASIFICATION_TYPE(),
            description: consolidatedDocumentName
          },
          files: [consolidatedPDFFile],
          fileName: consolidatedDocumentName,
          notifyUser: false
        });
        if (withError) {
          throw "Failed To Upload Document to Classification";
        }
        await this.LOAD_DOCUMENTS({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
        this.log("Saved to documents");
        showToast("success", "consolidatedPdfSaved");
      } catch (e) {
        this.savingStatus = false;
        Err.handle(e, this.details, "consolidatedPdfNotSaved");
      } finally {
        this.saving = false;
      }
    }
  })
});